import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import vindrApi from "../utils/vindrapi";


export interface diagProps {
	setup: (value: string) => void;
	scenario: object;
	workMode: object;
	map: object;
	onClose: (value: string) => void;
	onConfirm: (value: string) => void;
	onAfter: object;
}

export default function DialogRequestOwners(props: diagProg) {
	const [status, setStatus] = useState({sent:null, message:''});
	var { onClose, setup, scenario, projectid, workMode } = props;
	
	setup = {...setup, icon:{class:'ri-information-line', color:'info'}};
	
	const handleClose = () => {
		onClose();
		if(setup.onAfter)
			setup.onAfter();
	};
	const handleExit = () => {
		setStatus({sent:null, success:false, message:''});
	};

	const handleConfirm = (data) => {
		//map.current.controlBar.getButton('save').elButton.classList.add('disabled');
		setStatus({sent:false, success:false, message:'Requesting...'});
		let self = this;
		//saveguard for testing

		//console.log(scenario);
		vindrApi.requestOwners(projectid, scenario.scenario_id, workMode.value).then((response)=>{
			//console.log(response);

			setStatus({sent:true, success:true, message:'Request has been sent'});
			//redirect with timout

			setTimeout(()=>{handleClose()}, 2000);
			
		}).catch((e)=>{
			setStatus({sent:true, success:false, message:'Error requesting owners'});
		});
	};

	return (
		<Modal show={setup.open} onHide={handleClose} onExited={handleExit} centered>
			<Modal.Header closeButton>
				<Modal.Title>Request Owners</Modal.Title>
			</Modal.Header>

			{status.sent === null ? (
				<React.Fragment>
					<Modal.Body>
						<Row className="mb-3 dialog-feedback">
							{setup.icon ? (
								<Col xs="12" className="dialog-feedback-icon text-center">
									<i className={setup.icon.class + ' text-' + setup.icon.color} />
								</Col>							
							) : ''}
							
							<Col xs="12" className="dialog-feedback-text sm mb-3">
								Requesting landowners within the project boundary will cost money in Sweden and Estonia.
								<br />
								<br />
								The process may take several minutes to finish so please refresh this page manually to check for updates.
								<br />
								<br />
								Are you sure you want to continue?
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<Button className="me-auto" onClick={handleClose} variant="secondary">{setup.btnCloseText ? setup.btnCloseText : 'No'}</Button>
						<Button onClick={handleConfirm} variant="success">{setup.btnSaveText ? setup.btnSaveText : 'Yes'}</Button>
					</Modal.Footer>
				</React.Fragment>
			) : (
			<Modal.Body>
				<Row className="mb-3 dialog-feedback">
					<Col xs="12" className="dialog-feedback-icon text-center">
						{
						status.sent ?
							(status.success ? 
								(<i className="ri-checkbox-circle-line text-success"></i>)
								:
								(<i className="ri-error-warning-line text-warning"></i>)
							)
							:
							(<Spinner animation="border" variant="info" className="mt-5" />)
						}
					</Col>
					<Col xs="12" className="dialog-feedback-text mb-5">
						{status.message}
					</Col>
				</Row>
			</Modal.Body>	
			)}
		</Modal>
	);
} 
